// infra-fixture original source (FIXTURE)
export const API_BASE = process.env.FIXTURE_API_BASE || '/api/v1';
export const listUsers = () => fetch('/api/v1/users');
export const getItem = (id: number) => fetch(`/api/v1/items/${id}`);
// only in the original source, never in the shipped bundle:
export const exportAll = () => axios.get('/api/v1/admin/export');
export const gql = (q: string) => fetch('/graphql', { method: 'POST', body: JSON.stringify({ query: q }) });
